import { AuthAction } from "../actions/users";
import TYPES from "../types/users";

interface State {
  isLoading: boolean;
  list: MockUser[];
  success: boolean;
}

const initialState: State = {
  success: false,
  isLoading: false,
  list: [],
};

const reducer: (state: State, action: AuthAction) => State = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TYPES.START:
      return {
        ...state,
        isLoading: true,
      };
    case TYPES.SUCCESS:
      return {
        isLoading: false,
        success: true,
        list: action.payload,
      };
    case TYPES.FAIL:
      return {
        isLoading: false,
        success: false,
        list: [],
      };
    default:
      return state;
  }
};

export default reducer;
